import { IProvider } from "../../models/index";
import { addProvider } from "../../services/index";
import { toastError, toastSuccess } from "../../utils/index";
import { Toast } from "primereact/toast";
import { useMutation, useQueryClient } from "react-query";

export const useAddProviderData = (toast: React.RefObject<Toast>) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading: addProviderIsLoading } = useMutation(
    async (provider: IProvider) => await addProvider(provider),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("provider");
        toastSuccess(toast, "Provider Added");
      },
      onError: () => {
        toastError(toast, "Provider not Added");
      },
    }
  );
  return { mutate, addProviderIsLoading };
};
